import React from 'react';

export interface ScoreBarProps {
    width?: string;
    height?: string;
    golden?: boolean;
    percent: number;
    number: number;
    className?: string;
    numberSize?: string;
    numberAlign?: 'left' | 'right';
    startFrom?: 'left' | 'right';
    numberText?: string;
}

const BarFFXIV: React.FC<ScoreBarProps> = ({
    width = 'w-full',
    height = 'h-2',
    golden = false,
    percent,
    number,
    className = '',
    numberSize = 'text-sm',
    numberAlign = 'right',
    startFrom = 'left',
    numberText,
}) => {
    return (
        <div className={`${width} ${height} bg-slate-800 rounded-sm border relative ${golden ? 'border-yellow-500 shadow-[0_0px_10px_#eab308]' : 'border-blue-400 shadow-[0_0px_10px_#2563eb]'} ${className}`}>
            <div
                className={`absolute top-0 h-full bg-white rounded-sm ${startFrom === 'left' ? 'left-0' : 'right-0'}`}
                style={{ width: number === 0 ? '0%' : `${percent}%` }}
            />
            <div className={`font-contrax ${numberSize} text-${numberAlign} text-shadow-medium-border absolute bottom-[-14px] ${numberAlign === 'right' ? 'right-0' : 'left-0'} ${golden ? 'text-yellow-200 shadow-amber-900' : 'shadow-blue-900'}`}>
                {numberText || number}
            </div>
        </div>
    );
};

export default BarFFXIV;
